import Tooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";
import CheckGreenIcon from "assets/images/icons/check-green.svg";
import UnCheckRedIcon from "assets/images/icons/uncheck-red.svg";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";

import { useBoundStore } from "useStore";

export default function MeliStatus({ row }) {
  const cmEditedRows = useBoundStore((state) => state.cmEditedRows[row.id]);
  const feedbackByRow = useBoundStore((state) => state.cmFeedbackByRow) || {};
  const lookupKey = `${row.itemid}-${row.deal_id}`;
  const feedback = feedbackByRow[lookupKey];
  const status = row.notification_status;
  const isSelected = cmEditedRows?.id === row.id;

  const displayState = (() => {
    if (feedback && !feedback?.success) return "error";
    if (status === "Pendiente") return "pending";
    if (status === "Confirmado") return "success";
    if (status === "Error") return "error";
    return "idle";
  })();

  if (isSelected) return null;

  const renderIcon = () => {
    switch (displayState) {
      case "pending":
        return (
          <Tooltip title="Pendiente de procesar">
            <AccessTimeFilledIcon sx={{ fontSize: 20, color: "#FF7A39" }} />
          </Tooltip>
        );

      case "sent":
        return (
          <Tooltip title="Enviado">
            <ArrowCircleRightIcon sx={{ fontSize: 26, color: "#2196F3" }} />
          </Tooltip>
        );

      case "success":
        return (
          <Tooltip title="Publicado">
            <Box component="span" sx={{ display: "flex" }}>
              <img
                src={CheckGreenIcon}
                alt="Success"
                style={{ width: 20, height: 20 }}
              />
            </Box>
          </Tooltip>
        );

      case "error":
        return (
          <Tooltip title={feedback?.message || "Error"}>
            <Box component="span" sx={{ display: "flex" }}>
              <img
                src={UnCheckRedIcon}
                alt="Error"
                style={{ width: 20, height: 20 }}
              />
            </Box>
          </Tooltip>
        );

      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      {renderIcon()}
    </Box>
  );
}
